import { Button, BoxProps, ButtonProps, Box } from "@chakra-ui/react";

type Props = BoxProps & ButtonProps;

export default function MaybeButtonLink({ onClick, ...rest }: Props) {
  if (onClick) {
    return (
      <Button
        variant="link"
        onClick={onClick}
        display="inline"
        color="magenta.veryDark"
        textAlign="inherit"
        _hover={{ color: "magenta.dark" }}
        {...rest}
      />
    );
  }

  return <Box as="span" {...rest} />;
}
